type ToggleConfiguration = {
  field: string;
  label: string;
};

export const organizationToggles: ToggleConfiguration[] = [
  {
    field: 'test',
    label: 'Test',
  },
  {
    field: 'features.enabledAIAgent',
    label: 'Mira',
  },
  {
    field: 'features.enabledSourcing',
    label: 'Sourcing Enabled',
  },
  {
    field: 'features.enabledExportEmails',
    label: 'Email Export Enabled',
  },
  {
    field: 'features.enabledExportCurrentJobInfo',
    label: 'Current Job Info Export Enabled',
  },
  {
    field: 'features.enabledNaturalLanguageSourcing',
    label: 'Natural Language Sourcing Enabled',
  },
  {
    field: 'features.enabledNaturalLanguageSourcingBooleans',
    label: 'Natural Language Sourcing Boolean Queries Enabled',
  },
  {
    field: 'features.enabledNaturalLanguageFilteringProjectContacts',
    label: 'Natural Language Sourcing Filter Project Contacts',
  },
  {
    field: 'features.enabledSalesProjects',
    label: 'Sales Projects',
  },
  {
    field: 'features.enabledExcludeViewedFilter',
    label: 'Can Exclude Viewed Candidates',
  },
  {
    field: 'features.enabledGenderFilter',
    label: 'Gender Filter Enabled',
  },
  {
    field: 'features.enabledAddToProjectByLinkedIn',
    label: 'Add to project by LinkedIn URL',
  },
  {
    field: 'features.enabledAIProjectRecommendations',
    label: 'AI Project Contact Recommendations',
  },
  {
    field: 'features.enabledEnrichByElasticSearchOnly',
    label: 'Restrict enrichments to PDL',
  },
  {
    field: 'features.enabledPromotedJobs',
    label: 'Promoted Jobs Enabled',
  },
  {
    field: 'features.enabledUserLevelSourcingSettings',
    label: 'Enable User Level Sourcing Settings',
  },
  {
    field: 'features.enabledMgbSearch',
    label: 'MGB Search',
  },
];
